export const NotificationType = {
  ANSWER_REJECTION_MAIL: 'ANSWER_REJECTION_MAIL', // 回答差し戻し
  RE_ANSWER_REQUEST_MAIL: 'RE_ANSWER_REQUEST_MAIL', // 回答取り下げ依頼
  CSV_DOWNLOAD_SUCCESS_MAIL: 'CSV_DOWNLOAD_SUCCESS_MAIL', // スコアCSVダウンロード成功
  CSV_DOWNLOAD_FAILED_MAIL: 'CSV_DOWNLOAD_FAILED_MAIL', // スコアCSVダウンロード失敗
  PDF_DOWNLOAD_SUCCESS_MAIL: 'PDF_DOWNLOAD_SUCCESS_MAIL', // PDFダウンロード成功
  PDF_DOWNLOAD_FAILED_MAIL: 'PDF_DOWNLOAD_FAILED_MAIL', // PDFダウンロード失敗
  ATTACH_FILE_DOWNLOAD_SUCCESS_MAIL: 'ATTACH_FILE_DOWNLOAD_SUCCESS_MAIL', // 添付ファイル一括ダウンロード成功
  ATTACH_FILE_DOWNLOAD_FAILED_MAIL: 'ATTACH_FILE_DOWNLOAD_FAILED_MAIL', // 添付ファイル一括ダウンロード失敗
  IMPROVEMENT_PLAN_MAIL_FROM_BUYER: 'IMPROVEMENT_PLAN_MAIL_FROM_BUYER', // バイヤーからの改善計画メッセージ受信
  IMPROVEMENT_PLAN_MAIL_FROM_SUPPLIER: 'IMPROVEMENT_PLAN_MAIL_FROM_SUPPLIER', // サプライヤーからの改善計画メッセージ受信
  ESG_DATA_INVITATION_MAIL: 'ESG_DATA_INVITATION_MAIL', // ESGデータ招待
  ESG_DATA_INVITATION_COMPLETE_MAIL: 'ESG_DATA_INVITATION_COMPLETE_MAIL', // ESGデータ招待完了
  ASUENE_REMIND_MAIL: 'ASUENE_REMIND_MAIL', // 回答リマインド（自社回答）
  BUYER_REMIND_MAIL: 'BUYER_REMIND_MAIL', // 回答リマインド（バイヤー）
} as const

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]
